const React = require('react');

const CommonTypes = require('../common/Types.jsx');
const Config = require('../utility/Config.jsx');
const ContentContainer = require('../common/ContentContainer.jsx');
const Image = require('./Image.jsx');
const Item = require('./Item.jsx');
const _ItemContainer = require('../common/ItemContainer.jsx');
const _ItemContainerV2 = require('../common/ItemContainerV2.jsx');
const ItemMeta = require('./ItemMeta.jsx');
const Name = require('../utility/Name.jsx');
const Token = require('../utility/Token.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

const ItemBlocks = {
    get: (group, data) => [
        ...CommonTypes.BlocksV2.content.get(group),
        {
            id: Name.Block.Inventory.Image,
            component: Image.Component,
            config: {
                Block: Image.TypeConfigV2.panel.block(),
                Style: Image.TypeConfigV2.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: ItemMeta.Component,
            config: {
                Block: ItemMeta.TypeConfig.panel.block(data),
                Style: ItemMeta.TypeConfig.panel.style()
            },
            display: 'Item Meta',
            group,
            image: ''
        }
    ]
}

function ItemContainerV2(props) {
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: props.config });
    return (
        <ItemContainer
            {...props}
            itemContentContainer={ItemContentContainer}
            v2={true}
            visibility={props.config && props.config.config && props.config.config.Visibility}
            visibilityHash={visibilityHash} />
    )
}

const _ItemContentContainer = Config.withBlockRendering(ContentContainer, ItemBlocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                return { renderHeader: props.index == 0 }
            }
    }
});
function ItemContentContainer(props) {
    let config = props.contentConfig;
    if (!config && props.config && props.config.config && props.config.config.Block && props.config.config.Block.design && props.config.config.Block.design.Config) {
        config = Utilities.Config.getDeepCopy(props.config.config.Block.design);
    }
    let componentData;
    if (props.componentData) {
        componentData = props.componentData;
        if (componentData && componentData.length) {
            componentData = componentData[0];
        }
        if (componentData && !componentData.itemData && config && config.Config && config.Config.blocks) {
            let temp;
            for (let i = 0; i < config.Config.blocks.length; i++) {
                temp = config.Config.blocks[i];
                if (!temp.type || temp.type.value != Name.Block.Inventory.Image) {
                    continue;
                }
                config.Config.blocks = [temp];
                break;
            }
        }
    } else if (props.data && props.data.Inventory && props.data.Inventory.length) {
        componentData = { itemData: { ...props.data.Inventory[0] } };
        if (componentData.itemData.Images && componentData.itemData.Images.length) {
            componentData.image = { ...componentData.itemData.Images[0] };
        }
    }
    if (!componentData) {
        componentData = {};
    }
    return <_ItemContentContainer {...props} {...componentData} contentConfig={config} />
}

const TypeConfigV2 = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "height": {
                                "unit": "px",
                                "value": "600"
                            },
                            "width": {
                                "unit": "px",
                                "value": "520"
                            }
                        },
                        "Style": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Image
                    }
                },
                {
                    "config": {
                        "Block": {
                            "design": ItemMeta.TypeConfig.defaultDesign(data)
                        },
                        "Style": {}
                    },
                    "id": `${Name.Block.Inventory.Meta}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Meta
                    }
                }
            ]
        },
        "Type": Name.Content.TearsheetItem
    }),
    panel: {
        block: () => _ItemContainerV2.TypeConfig.panel.block('block', Name.Content.TearsheetItem),
        includes: () => {
            return {
                options: [
                    {
                        display: 'Include Additional Images',
                        displayExport: 'Additional Images',
                        fullWidth: true,
                        group: 'block',
                        name: 'AdditionalImages',
                        type: 'checkbox',
                        value: true,
                        configurableDuringExport: function () { return true; }
                    }
                ]
            }
        },
        style: () => _TypeConfig.panel.layoutStyleV2('block', undefined, {}, undefined, {}),
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Edition Info', name: Token.Inventory.Edition, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Edition, config, Name.Block.Inventory.Meta) },
                    { display: 'Created Date', name: Token.Date, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Date, config, Name.Block.Inventory.Meta) },
                    { display: 'Medium', name: Token.Inventory.Medium, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Medium, config, Name.Block.Inventory.Meta) },
                    { display: 'Signature Placement', name: Token.Inventory.Signature, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Signature, config, Name.Block.Inventory.Meta) },
                    { display: 'Dimensions', name: Token.Inventory.Dimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Dimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Dimensions', name: Token.Inventory.AlternateDimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternateDimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Framing', name: Token.Inventory.Framed, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Framed, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Number', name: Token.Inventory.Number, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Number, config, Name.Block.Inventory.Meta) },
                    { display: 'SKU', name: Token.Inventory.SKU, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.SKU, config, Name.Block.Inventory.Meta) },
                    { display: 'Location', name: Token.Inventory.Location, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Location, config, Name.Block.Inventory.Meta) },
                    { display: 'Retail Price', name: Token.Inventory.Price, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Price, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Prices', name: Token.Inventory.AlternatePrices, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternatePrices, config, Name.Block.Inventory.Meta) },
                    { display: 'Price Override', name: Token.Inventory.DisplayPrice, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.DisplayPrice, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Notes', name: Token.Notes, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Notes, config, Name.Block.Inventory.Meta) },
                    { display: 'Private Inventory Notes', name: Token.PrivateNotes, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.PrivateNotes, config, Name.Block.Inventory.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

// #region LEGACY

class ItemContainer extends React.Component {
    constructor(props) {
        super(props);

        this.containerStyle = {};
        if (props.collateralType == 0) {
            this.containerStyle.marginBottom = '200px';
        }

        this.handleComponentContent = this.handleComponentContent.bind(this);
        this.handleComponentType = this.handleComponentType.bind(this);
    }

    handleComponentContent(contentData, pageHeader, containerHandler) {
        const content = [];
        if (!containerHandler) {
            return content;
        }
        const component = this;
        let includes = {};
        if (component.props.config) {
            if (component.props.config.Config && component.props.config.Config.Includes) {
                includes = component.props.config.Config.Includes;
            } else if (component.props.config.config && component.props.config.config.Includes) {
                includes = component.props.config.config.Includes;
            }
        }
        if (!contentData || contentData.length == 0) {
            return [containerHandler(0, 0, [{ index: content.length }], pageHeader)]
        }
        contentData.forEach(function (d, i) {
            const insertInventoryPageBreak = i < contentData.length - 1;
            if (component.props.builder || !includes.AdditionalImages) {
                let image;
                if (d.Images && d.Images.length > 0) {
                    image = d.Images[0];
                }
                content.push(containerHandler(content.length, i, [{ image: image, index: content.length, itemData: d }], pageHeader, insertInventoryPageBreak));
            } else if (!d.Images || d.Images.length == 0) {
                content.push(containerHandler(content.length, i, [{ index: content.length, itemData: d }], pageHeader, insertInventoryPageBreak));
            } else {
                d.Images.forEach(function (image, imageIndex) {
                    content.push(containerHandler(content.length, i, [{ alt: d.Title, image, index: content.length, itemData: imageIndex == 0 ? d : undefined }], pageHeader, insertInventoryPageBreak || imageIndex < d.Images.length - 1));
                });
            }
        });
        return content;
    }

    handleComponentType(type) {
        switch (type) {
            case Name.Block.Inventory.Meta:
                return ItemMeta.Component;
            case 'itemCustomMeta':
                return Item.CustomMeta.Component;
            case 'itemDimensions':
                return Item.Dimensions.Component;
            case 'itemImage':
            case Name.Block.Inventory.Image:
                return Image.Component;
            case 'itemNotes':
                return Item.Notes.Component;
            case 'itemPrivateNotes':
                return Item.PrivateNotes.Component;
            case 'itemSignature':
                return Item.Signature.Component;
            default:
                return null;
        }
    }

    render() {
        const data = this.props.data || {};
        let className = 'itemContainer pageBreakInsideAvoid';
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        const PageComponent = this.props.v2 ? _ItemContainerV2.Page : _ItemContainer.Page;
        return (
            <PageComponent
                {...this.props}
                className={className}
                containerStyle={this.containerStyle}
                items={data.Inventory}
                onComponentContent={this.handleComponentContent}
                onComponentType={this.handleComponentType} />
        );
    }
}
const TypeConfig = {
    panel: {
        ..._ItemContainer.TypeConfig.panel,
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Additional Images', name: 'AdditionalImages', type: 'checkbox', value: true, configurableDuringExport: function () { return true; } }
                ]
            };
        }
    }
};

// #endregion LEGACY

module.exports = {
    Blocks: ItemBlocks,
    ContentContainer: ItemContentContainer,
    PageV2: ItemContainerV2,
    TypeConfigV2,

    // LEGACY
    Page: ItemContainer,
    TypeConfig
};